"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
require("./AccessoryButton.scss");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
var AccessoryButton = function AccessoryButton(_ref) {
  var handleReduceBtn = _ref.handleReduceBtn,
    handleAddBtn = _ref.handleAddBtn,
    rightBtnImage = _ref.rightBtnImage,
    leftBtnImage = _ref.leftBtnImage,
    deviceImage = _ref.deviceImage,
    list = _ref.list,
    defaultAccessoryImg = _ref.defaultAccessoryImg;
  return list === null || list === void 0 ? void 0 : list.map(function (item) {
    var _item$asset, _item$ModelNumber;
    return /*#__PURE__*/_react.default.createElement("div", {
      className: "accessory-list-body"
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "accessory-leftpart"
    }, item !== null && item !== void 0 && (_item$asset = item.asset) !== null && _item$asset !== void 0 && _item$asset.url ? /*#__PURE__*/_react.default.createElement("img", {
      className: "accessory-image",
      alt: "",
      src: item.asset.url
    }) : /*#__PURE__*/_react.default.createElement("img", {
      className: "accessory-NoImage",
      alt: "",
      src: defaultAccessoryImg
    }), /*#__PURE__*/_react.default.createElement("span", {
      className: "accessory-title"
    }, (_item$ModelNumber = item["Model Number"]) === null || _item$ModelNumber === void 0 ? void 0 : _item$ModelNumber.slice(2), " GAL Tank")), /*#__PURE__*/_react.default.createElement("div", {
      className: "accessory-rightpart"
    }, /*#__PURE__*/_react.default.createElement("button", {
      className: "accessory-plusBtn",
      "data-testid": "accessory-plusBtn",
      onClick: function onClick() {
        return handleReduceBtn(item["Model Number"]);
      },
      disabled: item.count === 0
    }, /*#__PURE__*/_react.default.createElement("img", {
      src: rightBtnImage
    })), /*#__PURE__*/_react.default.createElement("input", {
      className: "accessory-input",
      "data-testid": "accessory-input",
      type: "text",
      value: item.count,
      disabled: true
    }), /*#__PURE__*/_react.default.createElement("button", {
      className: "accessory-minusBtn",
      "data-testid": "accessory-minusBtn",
      onClick: function onClick() {
        return handleAddBtn(item["Model Number"]);
      },
      disabled: item.count >= 9
    }, /*#__PURE__*/_react.default.createElement("img", {
      src: leftBtnImage
    }))));
  });
};
var _default = AccessoryButton;
exports.default = _default;